const Wrapper = (props) => {
  const { children } = props;

  return children;
};

export { Wrapper };
